import { render, staticRenderFns } from "./rule11.vue?vue&type=template&id=47dde2eb&scoped=true"
import script from "./rule11.vue?vue&type=script&lang=js"
export * from "./rule11.vue?vue&type=script&lang=js"
import style0 from "./rule11.vue?vue&type=style&index=0&id=47dde2eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dde2eb",
  null
  
)

export default component.exports